// routes
import { SnackbarProvider, useSnackbar } from 'notistack'
import Router from './routes';
import { React, useEffect, useState } from 'react';
import URLS from './services/urls.service';
import AppCache from './services/AppCache';

// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';

// ----------------------------------------------------------------------

export default function App() {

    return (
        <SnackbarProvider>
            <ThemeProvider>
                <ScrollToTop />
                <BaseOptionChartStyle />
                <Router />
            </ThemeProvider>
        </SnackbarProvider>
    );
}
